import { createContext } from 'react';

// Child components can set `active` to true to hide MainPage's mobile
// floating nav footer. The chat overlay on /artEvents/:id uses this so
// its input isn't buried under the footer when it's open.
const FooterSuppressContext = createContext({
  active: false,
  setActive: () => {},
});

export default FooterSuppressContext;
